module.exports = __webpack_public_path__ + "static/media/saumon.8324a614.jpeg";